import React, { useState } from "react";
import { SortDirection } from "../components/table-cell/TableHeaderCell";

export function useOrderBy(initialOrder = "") {
  const [orderBy, setOrderBy] = useState<string>(initialOrder);
  const getSortingDirection = (colName: string) => {
    if (orderBy === colName) return SortDirection.ascending;
    if (orderBy === `-${colName}`) return SortDirection.descending;
  };

  const handleSetSortingOrder = (colName: string, toggle = true) => {
    if (!toggle) {
      return () => {
        setOrderBy(colName);
      };
    }
    return () => {
      let _orderBy = colName;
      if (getSortingDirection(colName) === SortDirection.ascending) {
        _orderBy = `-${colName}`;
      }
      setOrderBy(_orderBy);
    };
  };

  return { orderBy, getSortingDirection, handleSetSortingOrder };
}
